import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { Badge } from "@mui/material";
import helpers from "utils/helpers";

const MessageList = ({
  messages,
  markAsRead,
  navigate,
  hoveredConversationId,
  setHoveredConversationId,
  t,
  maxItems = null,
}) => {
  const displayedMessages = maxItems ? messages.slice(0, maxItems) : messages;

  return (
    <ListGroup flush>
      {displayedMessages.map((conversation) => {
        const isRead = conversation.unreadCount === 0;

        return (
          <ListGroupItem
            key={conversation.reference_id}
            tag="div"
            onMouseEnter={() =>
              setHoveredConversationId?.(conversation.reference_id)
            }
            onMouseLeave={() => setHoveredConversationId?.(null)}
            className={`list-group-item-action py-3 px-4 position-relative sidenav-toggler ${
              !isRead ? "bg-blue-50" : "bg-white"
            } hover:bg-blue-100 transition`}
            onClick={() =>
              helpers.handleOpenConversation({
                conversation,
                navigate,
                markAsRead,
              })
            }
          >
            <div className="d-flex justify-content-between gap-3 flex-wrap">
              <div className="d-flex gap-3 flex-70">
                <div className="flex-shrink-0 mr-3">
                  {helpers.getMessageIcon({ type: conversation.context_type })}
                </div>

                <div className="flex flex-col truncate">
                  <h5
                    className={`mb-0 truncate subtitle-large ${
                      !isRead ? "font-bold text-[#111]" : "text-gray-800"
                    }`}
                  >
                    {conversation.title || t("page.messages.untitled", "Untitled conversation")}
                  </h5>

                  <small className="subtitle-small truncate">
                    {conversation.lastMessageKey
                      ? t(conversation.lastMessageKey)
                      : conversation.lastMessage
                      ? conversation.lastMessage.slice(0, 80)
                      : t("page.messages.noMessagesYet", "No messages yet")}
                  </small>
                </div>
              </div>

              <div className="d-flex flex-column align-items-end gap-1 flex-30">
                <div className="align-items-center">
                  {!isRead && (
                    <Badge
                      badgeContent={conversation.unreadCount}
                      className="custom-badge mr-3"
                    />
                  )}
                  <small>{helpers.getRelativeTimeForMessages(conversation.lastMessageAt || conversation.updatedAt, t)}</small>
                </div>

                {!isRead &&
                  hoveredConversationId === conversation.reference_id &&
                  setHoveredConversationId && (
                    <button
                      className="btn btn-xs btn-outline-primary mt-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        markAsRead(
                          conversation.reference_id,
                          conversation.context_type,
                          conversation.channel
                        );
                      }}
                    >
                      {t("page.notifications.markAsRead", "Mark as read")}
                    </button>
                  )}
              </div>
            </div>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
};

export default MessageList;
